/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import TitleBar from '../../components/titleBar/title_bar'
import { Header, Segment } from 'semantic-ui-react'
import moment from 'moment';
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import LoadingPlaceholder from '../../components/placeholderComponent/loadingPlaceholder';
import JobcardActionButton from './jobcardActionButton';
import JobcardStatus from './jobcardStatus'
import AgGridTable from '../../components/agGridComponent/agGridTable';
import cogoToast from 'cogo-toast';
import { DATE_YYYYMMDD } from '../../utils/constants';


const JobCard = (props) => {

    const [jobcardData, setjobcardData] = useState([])
    const [isloaded, setisloaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    const firstDay = new Date(y, m, 1);
    const lastDay = new Date(y, m + 1, 0);
    const startDate = moment(firstDay).format(DATE_YYYYMMDD)
    const endDate = moment(lastDay).format(DATE_YYYYMMDD)
    const jobCardType = props?.location?.state
   

    useEffect(() => {
        if (jobCardType !== null || undefined) {
            setisloaded(true)
            let data = JSON.stringify
                ({
                    api_token: localStorage.getItem('apiToken'),
                    customerNo: localStorage.getItem('customerNo'),
                    isTyreProduct: props.TyreId,
                    isAvailable: props.isAvailable,
                    userId: localStorage.getItem('userId'),
                    jobCardTypeId: jobCardType?.jobCardTypeId,
                    startDate: startDate,
                    endDate: endDate
                })

            Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobcardList`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorage.getItem('apiToken'),
                    "Access-Control-Allow-Origin": "*"
                }
            }).then((response => {
                setisloaded(false)
                setjobcardData(response.data.data)
            }))
                .catch(error => {
                    console.log(error?.response)
                    cogoToast.error(error.response?.data?.message)
                    setisloaded(false)
                })
        }
    }, [])


    useEffect(() => {
        if (props?.location?.state?.jobCardTypeId == undefined && jobCardType == null) {
            setisloaded(true)
            const data = JSON.stringify
                ({
                    api_token: localStorage.getItem('apiToken'),
                    customerNo: localStorage.getItem('customerNo'),
                    isTyreProduct: props.TyreId,
                    isAvailable: props.isAvailable,
                    userId: localStorage.getItem('userId')
                })

            Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobcardList`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorage.getItem('apiToken'),
                    "Access-Control-Allow-Origin": "*"
                }
            }).then((response => {
                setisloaded(false)
                setjobcardData(response.data.data)
            }))
                .catch(error => {
                    console.log(error?.response)
                    cogoToast.error(error.response?.data?.message)
                    setisloaded(false)
                })
        }
    }, [])


    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }

    const [searchValue, setsearchValue] = useState('')
    let handleSearch = (e, data) => {
        setsearchValue(data.value)
    }

    if (isloaded) {
        return (
            <React.Fragment>
                <TitleBar title="Job Card" LinkName="/add-jobcard" />
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {

        let columnDefs = [
            { headerName: 'Jobcard No', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Jobcard Type', field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Number', field: 'vehnumber', tooltipField: 'vehnumber', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Total Amount', field: 'amount', tooltipField: 'amount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Status', field: 'status', cellRenderer: 'statusRenderer', tooltipField: 'status', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Approver Name', field: 'approvedBy', tooltipField: 'approvedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle In Date', field: 'vehicleInDate', tooltipField: 'vehicleInDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Reference Number', field: 'refnumber', tooltipField: 'refnumber', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Meter Reading (Km)', field: 'meterReading', tooltipField: 'meterReading', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Jobcard Date', field: 'jobdate', tooltipField: 'jobdate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit/View/Delete ', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true, pinned: "right" },
        ]
        let rowData = []
        jobcardData.map((object, i) => {
            let temp = {}
            temp.adminEditFlag = object.adminEditFlag
            temp.adminDeleteFlag = object.adminDeleteFlag
            temp.code = object.jobCardno
            temp.name = object.jb_type === null ? '' : (object.jb_type.jobCardType == 'BATTERY' || object.jb_type.jobCardType == 'TYRE') ? object.jb_type.jobCardType.concat(object?.jobcardActivityName ? "-" + object?.jobcardActivityName.split(' ')[0] : "") : object.jb_type.jobCardType
            temp.vehnumber = object.vehicle_obj === null ? '' : object.vehicle_obj.vehicleNo
            temp.refnumber = object.refNo
            temp.meterReading = object.meterReading
            temp.branch = object.branch_obj ? object.branch_obj.branchName : ''
            temp.amount = object.totalAmt
            temp.cby = object.createdByName
            temp.jobdate = object.createdOn ? moment(object.createdOn).format('DD-MM-YYYY') : ''
            temp.vehicleInDate = object.vehicleInDate ? moment(object.vehicleInDate).format('DD-MM-YYYY') : ''
            temp.id = object.jobCardId
            temp.vehicleId = object.vehicleId
            temp.statusDate = object.jb_approval_status ? moment(object.jb_approval_status.updatedOn).format('DD-MM-YYYY') : ''
            temp.status = object.jb_approval_status !== null ? object.jb_approval_status.approvalStatusName : ''
            temp.statusId = object.jb_approval_status !== null ? object.jb_approval_status.approvalStatus : ''
            temp.approvedBy = object.jb_approval_status !== null ? object.jb_approval_status.approvedOrRejectedByName : ''
            temp.uby = object.updatedBy
            temp.udate = object.updatedOn ? moment(object.updatedOn).format('DD-MM-YYYY | HH:mm') : ''
            rowData[i] = temp
        })
        let frameworkComponents = {
            actionRenderer: JobcardActionButton,
            statusRenderer: JobcardStatus,
        }

        return (
            <React.Fragment>
                <div className="ag-theme-material agOver ">
                    <AgGridTable
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={searchValue}
                        extraComponents={frameworkComponents}
                        reload={getUpdate}
                        link="/add-jobcard"
                        hiddenNewPopupBtn={true}
                        BaseUrl={props}
                        showImport={true}
                        titleBarTitle="Jobcard"
                        handleSearch={handleSearch}
                        hiddenImportPopupBtn={true}
                    />
                </div>
            </React.Fragment>
        )
    }

}

export default JobCard